import React from 'react';
import './preloader.css';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="spinner"></div>
      <p>EvenTix</p>
    </div>
  );
};

export default Preloader;